import React from 'react';
import DefaultLayout from '../layouts/DefaultLayout';
import PageHeader from '../components/PageHeader';
import DefaultHelmet from '../seo/DefaultHelmet';
import beaconWidgetIds from '../settings/beacon-widget-ids';
import useBeaconWidget from '../hooks/useBeaconWidget';
import ContactPageTabs from '../sections/Contact/ContactPageTabs';
import useSchemaSettings from '../seo/schema/useSchemaSettings';
import { buildContactPageSchema } from '../seo/schema';

const ContactPage = ({pageContext}) => {
  const {
    title,
    slug,
    acfContactPage,
    pageHeader,
    themesList,
  } = pageContext;
  const tabs = acfContactPage?.tabs;
  tabs.themesList = themesList;
  const pageTitle = acfContactPage?.metaData?.title || title;
  const pageDescription = acfContactPage?.metaData?.description || 'Get in touch with us at UTD! We\'re available via email, or direct message. Your queries and feedback are valuable to us. Contact us today.';
  const pageKeywords = 'web development, UTD, contact form, web development company, web design, website development';
  const schemaContext = useSchemaSettings();
  const structuredData = buildContactPageSchema({
    schemaContext,
    title: pageTitle,
    description: pageDescription,
    path: `/${slug || 'contact-us'}/`,
  });

  if (!pageHeader?.title) {
    pageHeader.title = title;
  }

  useBeaconWidget(beaconWidgetIds.GENERAL);

  return (
    <DefaultLayout className="dark-theme">
      <DefaultHelmet title={pageTitle} description={pageDescription} keywords={pageKeywords} structuredData={structuredData}/>

      <PageHeader {...pageHeader} isGeneral={true}/>

      {tabs && <ContactPageTabs tabs={tabs}/>}
    </DefaultLayout>
  );
};

export default ContactPage;
